import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontWeight: '500'
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '45px'
  },
  main: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginRight: 30
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    paddingBottom: 30,
    '& span': {
      fontSize: '16px',
      fontWeight: 700,
      color: '#30287b',
      paddingBottom: 0
    },
    '& input, & .form-group > div': {
      minHeight: 44,
      marginTop: '10px',
      padding: '11px 13px',
      fontSize: '14px',
      color: '#30287b',
      background: 'transparent',
      border: '2px solid #30287b'
    },
    '& legend': {
      paddingTop: 5,
      textAlign: 'left'
    },
    '& .form-group': {
      padding: 0,
      fontFamily: 'var(--font-family-body)',
      fontWeight: 'normal',
      minHeitht: '150px',
      '& span': {
        fontFamily: 'var(--font-family-body)',
        fontWeight: 'inherit'
      }
    }
  },
  editor: {
    '& div[contenteditable]': {
      minHeight: '150px'
    }
  },
  checkAsStandard: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiCheckbox-root, .MuiFormControlLabel-root': {
      margin: '0px',
      padding: '0px 10px 0px 0px'
    }
  },
  box: {
    gridColumn: '1 / 3',
    border: '2px solid #30287b',
    marginBottom: 15,
    '& h4': {
      marginBottom: 0,
      fontSize: '14px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '44px',
      textAlign: 'center',
      textTransform: 'uppercase',
      background: '#30287b',
      borderBottom: '2px solid #30287b'
    },
    '& > div': {
      display: 'grid',
      gridTemplateColumns: 'auto',
      gap: '15px',
      padding: '30px'
    },
    '& ul': {
      listStyleType: 'none',
      color: 'var(--primary-color)',
      padding: 0,
      fontSize: 14
    },
    '& ul li .MuiCheckbox-root': {
      color: 'var(--primary-color)'
    },
    '& ul li .MuiFormControlLabel-root': {
      margin: 0
    }
  },
  plainButton: {
    display: 'block',
    width: '100%',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#ece5fe',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer'
  },
  shadowButton: {
    width: '100%',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#fbbb33',
    border: 'none',
    borderRadius: '2px',
    boxShadow: '4px 4px #4200f5',
    cursor: 'pointer'
  },
  img: {
    width: '100%',
    height: 'auto'
  },
  hiddenInput: {
    visibility: 'hidden',
    opacity: 0,
    position: 'absolute',
    width: 0,
    height: 0,
    margin: 0,
    padding: 0
  },
  legend: {
    fontSize: '12px',
    fontStyle: 'italic',
    color: '#30287b',
    textAlign: 'center'
  },
  ul: {
    margin: '15px 0'
  },
  hide: {
    display: 'none'
  }
})

export default useStyles
